import getContactDataQuery from './get-contact-data-query';
import getEntitySchemaQuery from './get-entity-schema-query';
import getYachtForCharterContactDataQuery from './get-yacht-for-charter-contact-data-query';
import getYachtForSaleContactDataQuery from './get-yacht-for-sale-contact-data-query';

export {
  getContactDataQuery,
  getEntitySchemaQuery,
  getYachtForCharterContactDataQuery,
  getYachtForSaleContactDataQuery
};
